module.exports = __webpack_public_path__ + "static/dd378a31.03.gif";